// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class SubsAndMiscCosts {
  levelID: string;
  levelDescription: string;
  description: string;
  subcontractorCost: number;
  miscellaneousCost: number;
  typicalOfCountInArea: string;
  isSystemLevel: boolean;
  notes: string;
  isRiskItem: boolean;
}
